<script setup>
  const steps = [
    {
      title: 'Click "Add Slide" in the slides list',
      description: "Use the panel on the left to add your first slide.",
    },
    {
      title: "Pick a template",
      description: "Choose from cover slides, chart slides, section dividers, and more.",
    },
    {
      title: "Select any zone to edit it",
      description: "Click on titles, text areas, or charts to customize the content.",
    },
  ];
</script>

<template>
  <div class="space-y-6 text-sm">
    <div
      v-for="(step, index) in steps"
      :key="index"
      class="flex items-start gap-4">
      <span class="flex-shrink-0 w-7 h-7 rounded-full bg-primary/10 text-primary flex items-center justify-center text-xs font-semibold">{{ index + 1 }}</span>
      <div>
        <p class="font-medium">{{ step.title }}</p>
        <p class="text-muted-foreground mt-0.5">{{ step.description }}</p>
      </div>
    </div>
  </div>
</template>
